const defaultSelectors = [
  {
    key: "1month",
    text: "1 month",
    value: 1,
  },
  {
    key: "3month",
    text: "3 months",
    value: 3,
  },
  {
    key: "6month",
    text: "6 months",
    value: 6,
  },
  {
    key: "1year",
    text: "1 year",
    value: 12,
  },
  {
    key: "lifetime",
    text: "Lifetime",
    value: "lifetime",
  },
];

const Selector = ({ text = "", value, selectedValue, onClick }) => (
  <button
    data-button-type={selectedValue === value ? "primary" : "secondary"}
    onClick={(e) => onClick(e, value)}
  >
    {text}
  </button>
);

const RangeSelectors = ({
  selectors = defaultSelectors,
  onClick = () => {},
  selectedValue,
}) => (
  <div className="range-selectors">
    {selectors.map((props) => (
      <Selector {...props} onClick={onClick} selectedValue={selectedValue} />
    ))}
  </div>
);

export default RangeSelectors;
